import { styled } from '@mui/material/styles';

export const AlertWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(12, 0),

  '> div': {
    margin: '0 auto',

    [theme.breakpoints.up('sm')]: {
      width: '83.333333%',
    },

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
}));
